import { Route, Routes } from 'react-router-dom'

import { DataGridSyncUrlManagerProvider } from '@/contexts/DataGridSyncUrlManagerContext'
import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'
import BidDetailPage from '@/features/bidding/components/bidDetail/BidDetailPage'
import { BiddingContextProvider } from '@/features/bidding/contexts/BiddingContext'
import { ResetPtusContextProvider } from '@/features/bidding/contexts/ResetPtusContext'
import BiddingDashboard from '@/features/bidding/pages/BiddingDashboard'
import BiddingOverviewSummary from '@/features/bidding/pages/BiddingOverviewSummary'
import { BiddingTodoList } from '@/features/bidding/pages/BiddingTodoList'
import BidExports from '@/features/bidding/pages/BidExports'
import BidHistoriesView from '@/features/bidding/pages/BidHistoriesView'
import BidManualAccept from '@/features/bidding/pages/BidManualAccept'
import { BidManualAcceptSuccess } from '@/features/bidding/pages/BidManualAcceptSuccess'
import BidOfferCapacity from '@/features/bidding/pages/BidOfferCapacity'
import BidOfferCascading from '@/features/bidding/pages/BidOfferCascading'
import BidOfferConfirm from '@/features/bidding/pages/BidOfferConfirm'
import BidOfferConfirmPrice from '@/features/bidding/pages/BidOfferPriceConfirm'
import BidOfferPriceWrapper from '@/features/bidding/pages/BidOfferPriceWrapper'
import { BidOfferSuccess } from '@/features/bidding/pages/BidOfferSuccess'
import ExportMfrrBid from '@/features/bidding/pages/ExportMfrrBid'
import ImportAcceptedBid from '@/features/bidding/pages/ImportAcceptedBid'
import ImportIntradayEnergyOffer from '@/features/bidding/pages/ImportIntradayEnergyOffer'
import NavigateToError from '@/features/error/pages/NavigateToError'
import { useFeatureToggle } from '@/features/featureToggle/contexts/FeatureToggleContext'

export default function BiddingRoutes() {
  const { isEnabled } = useFeatureToggle()
  const { permissions } = usePermissions()
  const canMutateBidding = permissions.has('biddingMutation')

  const isBessDayAheadEnabled =
    isEnabled('FLEX_PORTAL_BID_CASCADING_MFRR_ENABLED') ||
    isEnabled('FLEX_PORTAL_BID_CASCADING_FCRD_ENABLED') ||
    isEnabled('FLEX_PORTAL_BID_CASCADING_FCRN_ENABLED')

  return (
    <BiddingContextProvider>
      <ResetPtusContextProvider>
        <Routes>
          <Route
            index
            element={
              <DataGridSyncUrlManagerProvider>
                <BiddingOverviewSummary />
              </DataGridSyncUrlManagerProvider>
            }
            path="/"
          />
          {canMutateBidding && <Route element={<BiddingTodoList />} path="/todo-list" />}
          {canMutateBidding && <Route element={<BidOfferCapacity />} path="/offer/create/capacity" />}
          {canMutateBidding && <Route element={<BidOfferPriceWrapper />} path="/offer/create/price" />}
          {canMutateBidding && <Route element={<BidOfferConfirm />} path="/offer/confirm/capacity" />}
          {canMutateBidding && <Route element={<BidOfferConfirmPrice />} path="/offer/confirm/price" />}
          {canMutateBidding && <Route element={<BidOfferSuccess />} path="/offer/success/:marketProgram" />}
          <Route element={<BidHistoriesView />} path="/view"></Route>
          <Route element={<BidDetailPage />} path="/:marketProgram/:bidType" />
          {canMutateBidding && <Route element={<BidManualAccept />} path="/manual-accept/:manualAcceptFlow" />}
          {canMutateBidding && (
            <Route element={<BidManualAcceptSuccess />} path="/manual-accept/:manualAcceptFlow/success" />
          )}
          <Route element={<BidExports />} path="/exports"></Route>
          {canMutateBidding && <Route element={<ImportAcceptedBid />} path="/import-accepted-bid" />}
          {canMutateBidding && isEnabled('FLEX_PORTAL_ENABLE_IMPORT_ENERGY_OFFERS') && (
            <Route element={<ImportIntradayEnergyOffer />} path="/import-energy-offers" />
          )}
          <Route element={<ExportMfrrBid />} path="/exports/mfrr"></Route>
          {isBessDayAheadEnabled && <Route element={<BidOfferCascading />} path="/offer/bess/day-ahead" />}
          <Route element={<BiddingDashboard />} path="/dashboard"></Route>

          <Route element={<NavigateToError statusCode={404} />} path="*" />
        </Routes>
      </ResetPtusContextProvider>
    </BiddingContextProvider>
  )
}
